import { Box } from "@mui/material";

import DevicesPageHeader from "./components/DevicesPageHeader";
import DevicesTable from "./components/DevicesTable";

const DevicesPage = (): JSX.Element => {
  return (
    <Box>
      <DevicesPageHeader />
      <DevicesTable />
    </Box>
  );
};

export default DevicesPage;
